import axios from "axios";
import { LMS_BASE_URL } from "../utils/http/http-common";

export const getLMSToken = async () => {
    const authToken = localStorage.getItem("token");
  try {
    const response = await axios.get(
      `${LMS_BASE_URL}/lms-user`,{
        headers:{
            Authorization:`Bearer ${authToken}`
        }
      }
    );
    return response;
  } catch (error) {
    return error.config.data;
  }
};